<!-- =========================================================================================
    File Name: Login.vue
    Description: Login Page
========================================================================================== -->

<template>
    <div class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center" id="page-login">
        <div class="vx-row justify-center items-center">

            <div class="vx-col p-20">
                <div class="mb-5 text-left">
                    <img src="@/assets/images/logo/logo-w.svg" alt="CFC Solutions"
                         class="fill-current stroke-current text-white inline-block">
                </div>
                <h1 class="d-theme-text-inverse text-2xl md:text-4xl mb-5">Outil de gestion &amp; <br>suivi de
                    facturation</h1>
                <h4 class="d-theme-text-inverse text-opacity-75 font-normal">Le plus court chemin <br>de la facture au
                    règlement</h4>
            </div>

            <div class="vx-col">
                <vx-card>
                    <div slot="no-body" class="full-page-bg-white rounded-lg d-theme-dark-bg">
                        <div class="p-10 login-tabs-container">

                            <div class="vx-card__title mb-4">
                                <h4 class="mb-4">Identification</h4>
                                <p>Bonjour et bienvenue, veuillez vous identifier:</p>
                            </div>

                            <vs-alert color="danger" icon="warning">
                                Attention ! La connexion a changé !
                                <br>Si c'est votre première connexion depuis la dernière mise à jour de l'application,
                                <br>Il faudra mettre à jour certaines informations suite à votre connexion.
                                <br>Si vous avez déjà mis à jour vos informations, veuillez vous identifier avec votre email
                            </vs-alert>

                            <div>
                                <form action="#" @submit.prevent="" @keydown.enter="validadeFields ? dologin(): false">
                                    <vs-input
                                        v-validate="'required|min:3'"
                                        data-vv-validate-on="change|input|keyup"
                                        name="email"
                                        icon-no-border
                                        icon="icon icon-user"
                                        icon-pack="feather"
                                        placeholder="email"
                                        v-model="email"
                                        class="w-full mt-8"/>
                                    <span class="text-danger text-sm">{{ errors.first('email') }}</span>

                                    <vs-input
                                        data-vv-validate-on="change|input|keyup"
                                        v-validate="'required'"
                                        type="password"
                                        name="password"
                                        icon-no-border
                                        icon="icon icon-lock"
                                        icon-pack="feather"
                                        placeholder="mot de passe"
                                        v-model="password"
                                        class="w-full mt-8"/>
                                    <span class="text-danger text-sm">{{ errors.first('password') }}</span>

                                    <div class="flex flex-wrap justify-between my-5">
                                        <router-link class="my-2" to="/pages/recover-password">Mot de passse oublié ?
                                        </router-link>
                                        <vs-button :disabled="!validadeFields" @click="dologin" class="float-right">
                                            S'identifier
                                        </vs-button>
                                    </div>
                                </form>
                            </div>

                        </div>
                    </div>
                </vx-card>
            </div>
        </div>
    </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
// For custom error message
import {Validator} from 'vee-validate'

const dict = {
  custom: {
    email: {
      required: 'Merci de saisir un email valide',
      min: 'Votre email doit contenir au moins 3 caractères.'
    },
    password: {
      required: 'Vous devez saisir un mot de passe'
    }
  }
}

// register custom messages
Validator.localize('fr', dict)

export default {
  data () {
    return {
      email: '',
      password: ''
    }
  },
  computed: {
    ...mapGetters('user', ['activeUser']),
    validateForm () {
      return !this.errors.any() && this.email !== '' && this.password !== ''
    },
    validadeFields () {
      return (!this.errors.any() && this.email !== '' && this.password !== '')
    }
  },
  methods: {
    ...mapActions('user', ['login']),
    forgotPassword () {
      alert('Action du mot de passe oublié')
    },
    dologin () {

      if (!this.validateForm) return

      this.$vs.loading()
      this.error = false

      this.login({
        email: this.email,
        password: this.password
      })
        .then(() => {
          this.$vs.loading.close();

          if(JSON.parse(this.activeUser.roles).includes('ROLE_LOGIN'))
          {
              this.$acl.change('login');
              this.$router.push({path: '/account-verification'})
          }else{
              if ((JSON.parse(this.activeUser.roles).includes('ROLE_ADMIN') || JSON.parse(this.activeUser.roles).includes('ROLE_ECHEANCEUR') || JSON.parse(this.activeUser.roles).includes('ROLE_MANAGER'))) {
                  this.$acl.change('admin')
              } else if (JSON.parse(this.activeUser.roles).includes('ROLE_USER')) {
                  this.$acl.change('subscriber')
              }
              this.$router.push({path: '/'})
          }

        })
        .catch(err => {
          this.$vs.loading.close()
          this.$vs.notify({
            title: 'Erreur d\'identification',
            text: err.response.data.error,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        })
    }
  }
}
</script>

<style lang="scss">
</style>
